import { ccc } from "@ckb-ccc/connector-react";
import { createContext, useEffect, useRef, useState } from "react";
import offCKBConfig from "../constants/offckb.config";
import { Client, Signer } from "@ckb-ccc/core";
import { ClientPublicDevnet } from "../client/CKBClient";
import { OffCKBConfig } from "../constants/offckb.config";
import { ckbNetwork } from "../constants/Constants";

const cccLib: any = ccc;

export type Network = "mainnet" | "testnet" | "devnet";

export interface CKBContextType {
  open: () => any;
  network: Network;
  disconnect: () => any;
  wallet?: any;
  internalAddress?: string;
  address?: string;
  addresses?: string[];
  signer?: Signer | undefined;
  setNetwork: (network: Network) => any;
  config: OffCKBConfig;
  client?: Client;
}

export const CKBContext = createContext<CKBContextType>({
  open: () => {},
  disconnect: () => {},
  setNetwork: (_network: Network) => {},
  config: offCKBConfig,
  network: ckbNetwork,
});

export default function CKBProvider({ children }: { children: any }) {
  const { open, disconnect, wallet, setClient, client } = cccLib.useCcc();
  const signer = ccc.useSigner();

  const [internalAddress, setInternalAddress] = useState<undefined | string>(
    undefined,
  );
  const [address, setAddress] = useState<undefined | string>(undefined);
  const [addresses, setAddresses] = useState<undefined | string[]>(undefined);
  const [network, _setNetwork] = useState<Network>(ckbNetwork);

  const needRedirect = useRef(false);

  const switchNetwork = (network: Network) => {
    disconnect();
    setTimeout(() => {
      _setNetwork(network);
      needRedirect.current = true;
      open();
    }, 300);
  };

  useEffect(() => {
    if (!signer) {
      console.log("Signer is undefined! Wallet probably not connected yet.");
      setInternalAddress(undefined);
      setAddress(undefined);
      setAddresses(undefined);
      return;
    }

    (async () => {
      console.log("Signer is defined! Wallet connected.");
      const internalAddress = await signer.getInternalAddress();
      const address = await signer.getRecommendedAddress();
      const addresses = await signer.getAddresses();
      console.log("Network: ", network);
      /*if (network === "devnet") {
        (signer as any).client_ = new ClientPublicDevnet();
      }*/
      setInternalAddress(internalAddress);
      setAddress(address);
      setAddresses(addresses);

      if (needRedirect.current) {
        needRedirect.current = false;
      }
    })();
  }, [signer]);

  useEffect(() => {
    console.log("Network changed to: ", network);
    setClient(
      network === "testnet"
        ? new cccLib.ClientPublicTestnet()
        : network === "mainnet"
          ? new cccLib.ClientPublicMainnet()
          : new ClientPublicDevnet(),
    );
    console.log("Setting network", network);
    localStorage.setItem("ckb_network", network);
  }, [network, setClient]);

  return (
    <CKBContext.Provider
      value={{
        client,
        config: offCKBConfig,
        network,
        setNetwork: switchNetwork,
        open: () => {
          needRedirect.current = true;
          open();
        },
        disconnect,
        wallet,
        signer,
        internalAddress,
        address,
        addresses,
      }}
    >
      {children}
    </CKBContext.Provider>
  );
}
